import { render, staticRenderFns } from "./SignInDialogue.vue?vue&type=template&id=8d85c5b6&"
import script from "./SignInDialogue.vue?vue&type=script&lang=ts&"
export * from "./SignInDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports